import { CSSObject } from '@emotion/core';

import { themeColor } from '@scripts/themes/cssVars';

import { scrollbarStyles } from '../../../../styles';

export const popupBodyStyles: CSSObject = {
    padding: 0,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(80vh - 200px)',
    marginTop: '8px',
};

export const loaderOverlayStyles: CSSObject = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
    backgroundColor: themeColor.white,
    opacity: 0.8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

export const mainGridStyles: CSSObject = {
    display: 'grid',
    gridTemplateColumns: '413px 1fr',
    flex: 1,
    minHeight: 0,
    paddingBottom: '30px',
    overflow: 'hidden',
};

export const leftColumnStyles: CSSObject = {
    backgroundColor: themeColor.lightBackground,
    padding: '24px',
    overflowY: 'auto',
    overscrollBehavior: 'auto',
    borderRadius: '20px',
    margin: '0 16px 0 30px',
    marginRight: '16px',
    height: '100%',
    minHeight: 0,
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '::-webkit-scrollbar': {
        display: 'none',
    },
};

export const rightColumnStyles: CSSObject = {
    padding: '24px 24px 0',
    overflowY: 'auto',
    height: '100%',
    minHeight: 0,
    ...scrollbarStyles.wide,
};

export const getFilterItemContainerStyles = (index: number): CSSObject => ({
    padding: '16px 0',
    ...(index === 0 && {
        paddingTop: 0,
    }),
    ...(index > 0 && {
        borderTop: `1px solid ${themeColor.middleBackground}`,
    }),
    ':last-child': {
        paddingBottom: 0,
    },
});
